import React from 'react';

import {ArchiveStatus, IS_ARCHIVED_TEXT, NOT_ARCHIVED_TEXT} from 'archive/ArchiveConstants';
import pickDefined from 'util/pickDefined';

import {FilterKey, SingleValueFilterWithDefault} from '../SearchConstants';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import SingleValueDropdownFilterForm from './base/SingleValueDropdownFilterForm';

export interface ArchiveStatusFilter extends SingleValueFilterWithDefault {
  key: FilterKey.ARCHIVE_STATUS;
  value: ArchiveStatus;
}

interface Props extends BaseFilterFormProps {
  filter: ArchiveStatusFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: ArchiveStatusFilter) => void;
}

export default function ArchiveStatusFilterForm(props: Props): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <SingleValueDropdownFilterForm
      {...skeletonProps}
      value={props.filter.value}
      onChangeValue={(value: ArchiveStatus) => {
        props.onChangeFilter({...props.filter, value});
      }}
      optionDatas={[
        {name: IS_ARCHIVED_TEXT, value: ArchiveStatus.IS_ARCHIVED},
        {name: NOT_ARCHIVED_TEXT, value: ArchiveStatus.NOT_ARCHIVED},
      ]}
      filterStyle={props.filterStyle}
    />
  );
}
